var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _rect5, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGift100 = function SvgGift100(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_726_65329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.04016,
    y: 27.9111,
    width: 13.68,
    height: 19.821,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.04016,
    y: 27.9111,
    width: 13.68,
    height: 19.821,
    rx: 2,
    fill: "#FDBC37",
    stroke: "#212833",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_726_65329)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_726_65329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.2798,
    y: 27.9111,
    width: 13.68,
    height: 19.821,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.2798,
    y: 27.9111,
    width: 13.68,
    height: 19.821,
    rx: 2,
    fill: "#FDBC37",
    stroke: "#212833",
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_726_65329)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_726_65329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20.8154,
    width: 15.8333,
    height: 9.5,
    rx: 2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20.8154,
    width: 15.8333,
    height: 9.5,
    rx: 2,
    fill: "#FDBC37",
    stroke: "#212833",
    strokeWidth: 6,
    mask: "url(#path-3-inside-3_726_65329)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_726_65329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.5834,
    y: 20.8154,
    width: 17.4167,
    height: 9.5,
    rx: 2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5834,
    y: 20.8154,
    width: 17.4167,
    height: 9.5,
    rx: 2,
    fill: "#FDBC37",
    stroke: "#212833",
    strokeWidth: 6,
    mask: "url(#path-4-inside-4_726_65329)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2501,
    y: 22.166,
    width: 23.9167,
    height: 6.5,
    transform: "rotate(90 27.2501 22.166)",
    fill: "#FFEDA2",
    stroke: "#212833",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5972 20.0618C21.8994 20.5702 20.8253 20.7751 19.4905 20.5064C18.1569 20.2379 16.6857 19.5081 15.4658 18.3259C14.246 17.1437 13.5947 15.8166 13.4674 14.6692C13.3399 13.5209 13.7335 12.6565 14.4313 12.1481C15.1291 11.6398 16.2032 11.4349 17.5379 11.7036C18.8715 11.972 20.3427 12.7018 21.5626 13.884C22.7825 15.0662 23.4338 16.3934 23.5611 17.5407C23.6885 18.689 23.2949 19.5534 22.5972 20.0618Z",
    stroke: "#212833",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4014 19.8933C24.7662 19.3595 24.4415 18.4857 24.667 17.3411C24.8919 16.1994 25.6579 14.9064 26.9836 13.7924C28.3093 12.6784 29.8482 12.0348 31.2068 11.8458C32.569 11.6563 33.609 11.9292 34.2441 12.4629C34.8793 12.9967 35.2041 13.8705 34.9786 15.0151C34.7537 16.1568 33.9877 17.4498 32.662 18.5638C31.3363 19.6778 29.7974 20.3214 28.4388 20.5104C27.0766 20.6999 26.0366 20.427 25.4014 19.8933Z",
    stroke: "#212833",
    strokeWidth: 3
  })));
};
export { SvgGift100 as ReactComponent };
export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,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'";